"use client";

import { Text } from "@/components/ui/Text";
import * as React from "react";
import type { BreadcrumbItem } from "./Breadcrumb";
import { Breadcrumb } from "./Breadcrumb";
import { useNavTrail } from "./NavTrail";

// The page header's left side. The title is the current crumb; ancestors come
// from the sidebar tree for the current URL unless `breadcrumb` overrides them.
export function PageTitle({
  children,
  breadcrumb,
  subtitle,
  subtitleClassName,
  currentAs = "h1",
}: {
  children: React.ReactNode;
  breadcrumb?: BreadcrumbItem[];
  subtitle?: React.ReactNode;
  subtitleClassName?: string;
  currentAs?: "span" | "h1";
}) {
  const trail = useNavTrail(children);
  const parents = breadcrumb ?? trail.parents;

  return (
    <div className="flex min-w-0 flex-1 items-center gap-2">
      <Breadcrumb currentAs={currentAs} items={[...parents, { label: children, icon: parents.length ? undefined : trail.icon }]} />
      {subtitle && <Text as="div" tone="tertiary" truncate className={subtitleClassName}>{subtitle}</Text>}
    </div>
  );
}
